import type { Realtime, TokenRequest } from "ably"

let ably: Realtime | undefined = undefined

export const getAbly = async (getTokenRequest: () => Promise<TokenRequest>) => {
  const Realtime = (await import("ably")).Realtime
  ably ??= new Realtime({
    logLevel: 1,
    authCallback: (_tokenParams, callback) => {
      getTokenRequest()
        .then((tokenRequest) => {
          callback(null, tokenRequest)
        })
        .catch((error: unknown) => {
          callback(JSON.stringify(error), null)
        })
    },
  })

  return ably
}

export const clearAbly = () => {
  ably?.close()
  ably = undefined
}
